import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useUpdateBusinessPlan } from 'services/businessPlan/hooks';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getAIAssistantReadinessPercent, getBusinessPlan } from 'store/useBusinessToolStore/selectors';

import { useBusinessToolAiContext } from 'pages/BusinessToolPage/components/BusinessToolAiProvider';

import { useAuthenticated } from 'hooks/useAuthenticated';

import { useModalContext } from 'components/ModalManager';
import { SaveProjectModal } from 'components/SaveProjectModal/SaveProjectModal';
import { SuggestAIGenerationModal } from 'components/SuggestAIGenerationModal/SuggestAIGenerationModal';

import { getValidatedMetadata } from 'helpers/metadataParser';

export const useHandleRequiredForAIInputBlur = () => {
  const { t } = useTranslation();
  const { showModal, hideModal } = useModalContext();
  const { generateWholeDocument } = useBusinessToolAiContext();
  const { isAuthenticated } = useAuthenticated();
  const AIAssistantReadinessPercent = useBusinessToolStore(getAIAssistantReadinessPercent);
  const { id: businessPlanId = '' } = useParams();
  const businessPlan = useBusinessToolStore(getBusinessPlan);

  const isShownAIGenerateWholeDocument = businessPlan.metadata.isShownAIGenerateWholeDocument;
  const updateMutation = useUpdateBusinessPlan();

  const generateWholeDocumentHandler = () => {
    if (!isAuthenticated) {
      showModal(SaveProjectModal, {
        onClose: hideModal,
        title: t('pleaseLogin'),
        description: t('loginForAIGeneration'),
      });
    } else {
      generateWholeDocument();
    }
  };

  const handleRequiredForAIInputBlur = async () => {
    if (AIAssistantReadinessPercent === 100 && !isShownAIGenerateWholeDocument) {
      showModal(SuggestAIGenerationModal, {
        handleClose: hideModal,
        submitHandler: generateWholeDocumentHandler,
      });
      const params = {
        id: businessPlanId,
        body: {
          ...businessPlan,
          metadata: JSON.stringify({
            ...getValidatedMetadata(businessPlan.metadata),
            isShownAIGenerateWholeDocument: true,
          }),
        },
      };
      await updateMutation.mutateAsync(params);
    }
  };

  return handleRequiredForAIInputBlur;
};
